import React from "react";
import "./PreSearchComp.css";
import { useUser } from "../../../../context/UserContext";

export default function PreSearchComp({title="Contacts"}) {
  const handleGenerateKey = () => {
    console.log("Generate new API key");
    // Add your API key generation logic here
  };

  const {user} = useUser();

  return (
    <div className="presearch-page-gc">
      <div className="presearch-card-gc">
        {/* Illustration */}
        <div className="presearch-illustration-gc">
          <div className="illustration-wrapper-gc">
            {/* Laptop */}
            <div className="laptop-gc">
              <div className="laptop-screen-gc"></div>
              <div className="laptop-base-gc"></div>
            </div>

            {/* People */}
            <div className="person-left-gc">
              <div className="head-gc"></div>
              <div className="body-gc"></div>
            </div>

            <div className="person-right-gc">
              <div className="head-gc"></div>
              <div className="body-gc"></div>
            </div>

            {/* Decorative elements */}
            <div className="decor-gc blue-gc"></div>
            <div className="decor-gc purple-gc"></div>
            <div className="decor-gc pink-gc"></div>
          </div>
        </div>

        {/* Text Content */}
        <div className="presearch-content-gc">
          <h1>Hi, {user?.firstname}!</h1>
          <p>Please find your {title}</p>
          {/* <p></p> */}
          {/* <button onClick={handleGenerateKey}>GENERATE NEW KEY</button> */}
          {/* <p className="footer-text">and go ahead.</p> */}
        </div>
      </div>
    </div>
  );
}
